import {Config} from '../../shared/types';
import {httpGetJson} from './http';

export const fetchConfig = () =>
  httpGetJson<Config>({path: `/account-ui/config`});
